export enum BOOK_PATHS {
  DISCERNMENT_OF_SPIRITS = "discernment_of_spirits",
  FACE_TO_FACE = "face_to_face",
  LETTERS_OF_FIRE = "letters_of_fire",
  THE_JOURNEY = "the_journey",
  PROPHECY = "prophecy",
  POSSESSING_THE_GATES_OF_THE_ENEMY = "possessing_the_gates_of_the_enemy",
}


export enum BOOK_NAMES_EN {
  DISCERNMENT_OF_SPIRITS = "Discerning the Spirit Realm",
  FACE_TO_FACE = "Face to Face with God",
  LETTERS_OF_FIRE = "Letters of Fire",
  THE_JOURNEY = "The Journey",
  PROPHECY = "Prophecy: Key to Unlocking God's Plan",
  POSSESSING_THE_GATES_OF_THE_ENEMY = "Possessing the Gates of the Enemy",
}

export enum BOOK_NAMES_AR {
  DISCERNMENT_OF_SPIRITS = "تمييز عالم الروح",
  FACE_TO_FACE = "وجهًا لوجه مع الله",
  LETTERS_OF_FIRE = "حروف من نار",
  THE_JOURNEY = "رحلة",
  PROPHECY = "النبوءة: مفتاح لفهم خطة الله",
  POSSESSING_THE_GATES_OF_THE_ENEMY = "امتلاك أبواب العدو",
}

export enum BOOK_LANGUAGE_EN  {
  EN = "ENGLISH",
  AR = "ARABIC",
}

export enum BOOK_LANGUAGE_AR  {
  EN = "الإنجليزية",
  AR = "العربية",
}